"use client";
import { Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";

interface ResolutionWarningOverlayProps {
  currentWidth: number;
  minWidth: number;
  onOverride: () => void;
}

export function ResolutionWarningOverlay({
  currentWidth,
  minWidth,
  onOverride,
}: ResolutionWarningOverlayProps) {
  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-sm z-50 flex items-center justify-center p-2">
      <div className="w-full max-w-xs mx-auto p-4 bg-card border border-border rounded-lg shadow-lg text-center space-y-3">
        {/* Icon */}
        <div className="w-10 h-10 mx-auto bg-orange-100 dark:bg-orange-900/20 rounded-full flex items-center justify-center">
          <Monitor className="w-5 h-5 text-orange-600 dark:text-orange-400" />
        </div>

        {/* Warning Message */}
        <div className="space-y-2">
          <h2 className="text-sm font-bold text-orange-600 dark:text-orange-400">
            Screen Too Small
          </h2>
          <p className="text-xs text-muted-foreground">
            Need {minWidth}px width minimum
          </p>

          <div className="bg-muted rounded p-2 text-xs">
            <div className="flex justify-between">
              <span>Current:</span>
              <span className="font-mono text-orange-600">
                {currentWidth}px
              </span>
            </div>
          </div>
        </div>

        {/* Override Button */}
        <div className="space-y-2">
          <Button
            onClick={onOverride}
            variant="destructive"
            size="default"
            className="w-full"
          >
            🚫 Override & Continue
          </Button>
          <p className="text-xs text-muted-foreground">
            May cause layout issues
          </p>
        </div>
      </div>
    </div>
  );
}
